module.exports = __webpack_public_path__ + "media/shared/assets/fonts/Inter-Regular-b35f79d43d03b9a20047efe416c35d08.woff2";